import { render, staticRenderFns } from "./OmnichannelProductsList.vue?vue&type=template&id=9ce5a874&scoped=true"
import script from "./OmnichannelProductsList.vue?vue&type=script&lang=ts"
export * from "./OmnichannelProductsList.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelProductsList.vue?vue&type=style&index=0&id=9ce5a874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce5a874",
  null
  
)

export default component.exports